import { render, staticRenderFns } from "./cuslicencelinfonoteHistory.vue?vue&type=template&id=2abe3ce5&scoped=true"
import script from "./cuslicencelinfonoteHistory.vue?vue&type=script&lang=js"
export * from "./cuslicencelinfonoteHistory.vue?vue&type=script&lang=js"
import style0 from "./cuslicencelinfonoteHistory.vue?vue&type=style&index=0&id=2abe3ce5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abe3ce5",
  null
  
)

export default component.exports